module.exports = __webpack_public_path__ + "../resources/img/weather_clear-night.f436482b.svg";